import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppInnerWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import SectionGate from '../../app/SectionGate';
import { AdminDispatch } from '../../app/store';
import { AdminState } from '../../reducers';
import { InitializationState, initialize } from './state/appSlice';

// Init gate for the data-source section. Acts as a route layout: the
// section's sub-routes live in the consolidated route table (app/Main.tsx) and
// render through the <Outlet /> that SectionGate provides once initialized.
const App = () => {
  const dispatch = useDispatch<AdminDispatch>();

  const { initializing, initialized, initError } = useSelector<
    AdminState,
    InitializationState
  >(state => state.appDataSource);
  useEffect(() => {
    dispatch(initialize());
  }, [dispatch]);

  return (
    <SectionGate
      initializing={initializing}
      initialized={initialized}
      hasError={!!initError}
      wrapper={AppInnerWrapper}
    />
  );
};

export default App;
